import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "dayjs/locale/id";

import DataEmpty from "../../../components/emptyState/dataEmpty";
import TableLoader from "../../../components/loading/tableLoader";
import CategoryMedia from "./Components/CategoryMedia";

const ListTargetMediaModule = () => {
  const { dataGetTargetMedia, loadingGetTargetMedia } = useSelector(
    (state) => state.service
  );

  // clean html
  const cleanHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");

    return doc.body.textContent || "";
  };

  return (
    <>
      <div className="card card-custom">
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Daftar Target Media
            </span>
          </h3>
        </div>
        <div className="card-body pt-0 pb-3">
          {loadingGetTargetMedia ? (
            <TableLoader />
          ) : (
            <div className="card-info-bottom">
              {dataGetTargetMedia?.length > 0 ? (
                <>
                  {dataGetTargetMedia?.map((item, index) => (
                    <div key={index} className="article-box">
                      <Link
                        to={`/admin/pm/detail-target-media/${item?.id}`}
                        className="article-left"
                      >
                        <h3 className="text-body">
                          {cleanHtml(item?.contentText?.substring(0, 100)) +
                            "..."}
                        </h3>
                      </Link>
                      <div className="article-right">
                        <CategoryMedia item={item?.targetMedia} />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <DataEmpty />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ListTargetMediaModule;
